// extracted by mini-css-extract-plugin
export default {"timer":"MatchUnlockTimer_timer__52MYf","message":"MatchUnlockTimer_message__hXNla","time":"MatchUnlockTimer_time__rAfNK","time_unit":"MatchUnlockTimer_time_unit__q9Pq+"};